<template>
  <v-data-table
    :headers="headers"
    :items="users"
    :search="search"
    @click:row="selectUser"
    class="elevation-1"
  >
  </v-data-table>
</template>
<script>
export default {
  name: "UserList",
  props: ["search"],
  data() {
    return {
      headers: [
        { text: "First name", value: "firstName" },
        { text: "Last name", value: "lastName" },
        { text: "Title", value: "title" },
        { text: "Organisation", value: "organization" },
        { text: "Email", value: "email" },
        { text: "Area(s)", value: "combinedAreas" }
      ],
    };
  },
  mounted() {
    this.$store.dispatch("dispatchGetUsers").then(() => {
      if (this.$route.query.userId) {
        let userId = this.$route.query.userId;
        let user = this.users.find(user => user.id == userId);
        this.selectUser(user);
      }
    });
  },
  methods: {
    selectUser(user) {
      console.log(user);
      this.$emit("selectUser", user);
    },
  },
  computed: {
    users() {
      return this.$store.state.users.map((user) => {
        if (user.areas) {
          user["combinedAreas"] = user.areas
            .map((area) => {
              return area.name;
            })
            .join(", ");
        }
        if (user.roles) {
          user["combinedRoles"] = user.roles
            .map((role) => {
              return role.name;
            })
            .join(", ");
        }
        return user;
      });
    },
  },
};
</script>
<style scoped>
.v-data-table {
  width: 100%;
}
</style>